import React from 'react';

const ScheduledPage = () => {
  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold mb-4">Posts programmés</h1>
      <p className="text-gray-600">Vos publications planifiées apparaîtront ici avec date/heure.</p>
    </div>
  );
};

export default ScheduledPage;
